import Swiper, { Pagination, EffectFade, Controller } from 'swiper';

class MediaTextSlider {
  constructor(el, wWidth) {
    this.wWidth = wWidth;
    this.$block = $(el);
    this.$copySwiper = this.$block.find('.media-text-slider__copy-wrap');
    this.$mediaSwiper = this.$block.find('.media-text-slider__media-wrap');
    this.$pagination = this.$block.find('.media-text-slider__pagination');
    this.$hoverContainer = this.$block.find(
      '.media-text-slider__hover-container'
    );
    this.speed = 500;

    this.init();
  }

  init() {
    const mediaOptions = {
      modules: [EffectFade, Controller],
      loop: true,
      effect: 'fade',
      speed: this.speed,
    };

    const copyOptions = {
      modules: [Pagination, EffectFade, Controller],
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      speed: this.speed,
      pagination: {
        el: this.$pagination[0],
        type: 'bullets',
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 1,
        renderBullet: (index, className) => {
          return `<span class="${className}"><img src="${theme.uri}/img/icon-bullet-red.svg" alt="Bullet"/></span>`;
        },
      },
    };

    if (this.wWidth < 768) {
      copyOptions.autoHeight = true;
    }

    // init
    this.copySwiperInstance = new Swiper(this.$copySwiper[0], copyOptions);
    this.mediaSwiperInstance = new Swiper(this.$mediaSwiper[0], mediaOptions);

    // controller
    this.copySwiperInstance.controller.control = this.mediaSwiperInstance;
    this.mediaSwiperInstance.controller.control = this.copySwiperInstance;

    // events
    this.$hoverContainer.on('click', this.nextSlide.bind(this));
  }

  nextSlide() {
    this.copySwiperInstance.slideNext(this.speed);
  }

  destroy() {
    if (this.copySwiperInstance) {
      this.copySwiperInstance.destroy(true, true);
      this.copySwiperInstance = null;
    }

    if (this.mediaSwiperInstance) {
      this.mediaSwiperInstance.destroy(true, true);
      this.mediaSwiperInstance = null;
    }

    this.$hoverContainer.off('click');
  }

  onResize(wWidth) {
    this.wWidth = wWidth;
    this.destroy();
    this.init();
  }
}

export default MediaTextSlider;
